module.exports = __webpack_public_path__ + "img/file.553908c4.svg";